import * as React  from 'react';
// import { connect } from 'react-redux'
// import { bindActionCreators } from 'redux';
import Base from './base';
import FormFileUpload from "../../FormComponents/formFileUpload";
import { Field} from 'redux-form';
import {
    MAX_UPLOAD_FILE_SIZE,
    INVALID_FILES_TO_UPLOAD,
     FILE_UPLOAD_URL
} from '../../../containers/WorkkardDetail/constants';
class File extends Base{
    constructor(props){
        super(props);
    }

    renderOnCard() {
        return (
            <div></div>
        )
    }
    renderOnGrid() {
        return (
            <div></div>
        )
    }
    renderOnDetail() {
        let {renderType, data, showLabel=false} = this.props;
        if(Array.isArray(data))
            data = data[0];
        if(renderType.toLowerCase() === 'activity'){
            return (showLabel) ?
                    (<li data-test={data.Label}><label>{data.Label}: </label>{data.Value?data.Value:'-'}</li>)
                :
                    (<li data-test={data.Value}>{data.Value?data.Value:'-'}</li>)
        } else if(renderType.toLowerCase() === 'workkard'){
            return (showLabel) ?
                    (<li data-test={data.Label}><label>{data.Label} </label>{data.Value?data.Value:'-'}</li>)
                :
                    (data.Value?data.Value:'-')
        } else{
            return (showLabel) ?
                    (<React.Fragment><label>{data.Label}: </label>{data.Value?data.Value:'-'}</React.Fragment>)
                :
                    (data.Value?data.Value:'-')
        }
    }

    renderOnCreate() {
        let {renderType, data, showLabel=true,onsaveAndUpdateFileCaption} = this.props;
        if(renderType.toLowerCase() === 'activity'){
        if(Array.isArray(data))
            data = data[0];
        return (
            <div className="formGroup">
            <label className="wth-3">Attachments</label>
            <Field
                component={FormFileUpload}
                name={data.Name}
                maxFileUploadSize={MAX_UPLOAD_FILE_SIZE}
                invalidFilesToUpload={INVALID_FILES_TO_UPLOAD}
                fileUploadUrl={FILE_UPLOAD_URL}
                allowMultiple={true}
                helpText=""
                label={""}
            />
            </div>
        )
        }
        else{
            return(
                null
            )
        }
    }
}

export default File;